import { render, staticRenderFns } from "./LottoInfoForm.vue?vue&type=template&id=2c3d4e7b&scoped=true&"
import script from "./LottoInfoForm.vue?vue&type=script&lang=js&"
export * from "./LottoInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d4e7b",
  null
  
)

export default component.exports